export default {
  title: 'Précommande',
  categories: {
    title: 'Les plus populaires',
  },
  header: {
    pickup: 'À emporter en 5 minutes',
  },
};
